import apiClient from './client';

export const login = (email, password) => apiClient.post('/auth/login', { email, password }).then((r) => r.data);
export const fetchMe = () => apiClient.get('/auth/me').then((r) => r.data);
export const logout = () => apiClient.post('/auth/logout').then((r) => r.data);
export const changeMyPassword = (currentPassword, newPassword) =>
  apiClient.patch('/auth/change-my-password', { currentPassword, newPassword }).then((r) => r.data);
